import { isArray, isBoolean, isValue } from 'bv-validator'
import { arr2Str, getExcelName, outputExcel } from 'bv-utils'
import type { ListData, OperateOption } from 'bv-typings'
import { defaultListData, formatStr } from 'bv-data'
import dayjs from 'dayjs'
import moment from 'moment'


const toggleTime = (params: any, field: string = 'date', start: string = 'start', end: string = 'end') => {
  if (isValue(params?.[field])) {
    const newParams = { ...params }
    const time = newParams[field]
    const startTime = time[0]
    const endTime = time[1]
    if (startTime && endTime) {
      newParams[start] = startTime
      newParams[end] = endTime
    }
    delete newParams[field]
    return newParams
  }
  return params
}

const getArrItem = (arr?: Record<any, any>[], field = 'id') => {
  return arr?.map(item => item[field])
}

const exportExcel = (options: OperateOption[], list: any[], title = '数据列表') => {
  outputExcel(
    [
      options.map(item => item.title),
      ...list.map(row => options.map(item => {
      const { key, format, isEnum, isMultiple, isTime, isBool } = item
      const value = row?.[key]
      if (isEnum) {
        if (isArray(value)) {
          return arr2Str(value.map((i: any) => isEnum[i]), '、')
        }
        return isEnum[value]
      }
      if (isMultiple) {
        return arr2Str(value, isBoolean(isMultiple) ? undefined : (isMultiple as string))
      }
      if (isTime) {
        return value ? dayjs(value).format(isBoolean(isTime) ? formatStr : (isTime as string)) : undefined
      }
      if (isBool) {
        return [ '否', '是' ][value]
      }
      return format ? format(value, row) : value
    })) ],
    getExcelName(title, list.length),
  )
}

const arr2Select =  (arr: any[]) => { return arr.map( (item) => ({ value: item, title: item }) ) }

const paramsArray2Str = function (params: { [x: string]: any; hasOwnProperty: (arg0: string) => any }) {
  const result = Object.assign({}, params)
  // eslint-disable-next-line no-restricted-syntax
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      if (isArray(params[key])) {
        result[key] = arr2Str(params[key])
      }
    }
  }
  return result
}

const getCurrentList = <T= any>(page: string, data: ListData<T>, model?: string) => (
  page === model ? (data || {}) : defaultListData
)

const getExcelData = (options: OperateOption[] = [], list: any[] = []) => {
  return [
    options.map(item => (item.title)),
    ...list.map(row => options.map(item => {
      const { key, format, isEnum, isMultiple, isTime, isBool } = item
      const value = row?.[key]
      if (isEnum) {
        if (isArray(value)) {
          return arr2Str(value.map((i: any) => isEnum[i]), '、')
        }
        return isEnum[value]
      }
      if (isMultiple) {
        return arr2Str(value, isBoolean(isMultiple) ? undefined : (isMultiple as string))
      }
      if (isTime) {
        return value ? moment(value).format(isBoolean(isTime) ? formatStr : (isTime as string)) : undefined
      }
      if (isBool) {
        return Boolean[value]
      }
      return format ? format(value, row) : value
    })),
  ]
}

export {
  toggleTime,
  getArrItem,
  exportExcel,
  arr2Select,
  paramsArray2Str,
  getCurrentList,
  getExcelData,
}
